<template>
  <v-container fluid class="fill-height">
    <v-card class="fill-height idcs-fill-width idcs-main-list main-back-img">
      <v-card-title>
        <i18n path="title.templates" class="text-h4 text-uppercase text-decoration-underline"></i18n>
        <v-spacer></v-spacer>
        <span>
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            v-model="search"
            clearable
            :label="$t('label.search')"
          ></v-text-field>
        </span>
      </v-card-title>
      <v-card-text style="position:relative;">
        <v-btn fab absolute bottom dark @click="edit" color="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-data-table
          :items="templates"
          :headers="headers"
          :search="search"
          :page.sync="currentPage"
          class="idcs-main-list transparent"
          :footer-props="foot_props"
          :no-data-text="$t('label.nodata')"
        >
          <template v-slot:item.action="{item}">
            <v-btn icon @click="edit(item)" color="primary">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="prepare2remove(item)" color="primary">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="d_edit" width="400">
      <v-card>
        <v-card-title class="primary lighten-4">
          <i18n path="dialog.edit_template" />
          <v-spacer></v-spacer>
          <v-btn icon @click="d_edit=false">
            <v-icon color="error">mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="back-img">
          <div class="mt-4 main-tpl-div">
            <div class="sender-div">{{$store.getters["user/sender"]}}</div>
            <v-textarea
              ref="msg"
              v-model="editedItem.text"
              auto-grow
              rows="2"
              autofocus
              color="brown"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{$t("button.update")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog v-model="d_confirm" :mode="dmode" @click:ok="confirmed" />
  </v-container>
</template>

<script>
//import api from "@/api.js";
import commonmixin from "@/mixins/commonlist.js";

export default {
  name: "Templates",
  mixins: [commonmixin],
  data() {
    return {
      d_edit: false,
      editedItem: {},
      tpl2remove: 0,
      editedIdx: -1,
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          width: 150,
          sortable: false,
        },
        { text: this.$t("fields.text"), value: "text" },
      ],
    };
  },
  computed: {
    templates() {
      return this.$store.getters["data/templates"];
    },
  },
  methods: {
    update() {
      if (!this.$refs.msg.validate()) return;
      if (this.editedIdx > -1) {
        this.$store.dispatch("data/UPDATE_TEMPLATE", {
          index: this.editedIdx,
          item: this.editedItem,
        });
      } else {
        this.$store.dispatch("data/INSERT_TEMPLATE", this.editedItem);
      }
      this.d_edit = false;
    },
    prepare2remove(i) {
      this.tpl2remove = i;
      this.dmode = "deleteTemplate";
      this.d_confirm = true;
    },
    remove() {
      this.$store.dispatch("data/DELETE_TEMPLATE", this.tpl2remove);
    },
    confirmed() {
      if (this.dmode == "deleteTemplate") this.remove();
    },
    edit(i) {
      if (!i) i = { text: "" };
      this.editedItem = { ...i };
      this.editedIdx = this.templates.indexOf(i);
      this.d_edit = true;
    },
    loadData() {
      this.$store.dispatch("data/LOAD_TEMPLATES");
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.back-img {
  background-image: url("../../public/img/sms_mail.svg");
  background-position: center;
}
.main-back-img {
  background-image: url("../../public/img/mail_random.svg");
  background-size: 450px;
  background-repeat: initial;
}
.main-tpl-div {
  border: solid 1px;
  border-radius: 25px;
  padding: 20px;
}
.sender-div {
  font-size: x-large;
  font-weight: 900;
}
</style>